"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGPieChart = void 0;
const react_1 = __importStar(require("react"));
const pie_1 = require("@nivo/pie");
const lodash_1 = require("lodash");
const common_1 = require("./common");
const configContext_1 = require("../../../contexts/configContext");
const TGPieChart = (props) => {
    // TODO: [S5-3587] Consolidate inline props with `defaultProps` to facilitate options/value property merging with default values.
    const chartProps = (0, react_1.useMemo)(() => (0, common_1.mergeChartProps)(props, SAMPLE_PROPS), [props]);
    const { legendPosition, colorPalette: colorPaletteName } = chartProps;
    const { colorPalettes, primaryPalette } = (0, configContext_1.useConfig)();
    const colors = (0, react_1.useMemo)(() => { var _a, _b, _c; return (_c = (_b = (_a = colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.find(x => x.name === colorPaletteName)) === null || _a === void 0 ? void 0 : _a.colors) !== null && _b !== void 0 ? _b : primaryPalette) !== null && _c !== void 0 ? _c : undefined; }, [colorPalettes, colorPaletteName]);
    return react_1.default.createElement(pie_1.ResponsivePie, Object.assign({ colors: colors, arcLabel: (datum) => `${(0, lodash_1.floor)(datum.value, 2)}`, margin: Object.assign({ top: 50, left: 60 }, (legendPosition === 'bottom' ? {
            right: 80,
            bottom: 80,
        } : {
            right: 130,
            bottom: 60,
        })), innerRadius: 0.5, padAngle: 0.7, cornerRadius: 3, activeOuterRadiusOffset: 8, borderWidth: 1, borderColor: {
            from: 'color',
            modifiers: [
                [
                    'darker',
                    0.2
                ]
            ]
        }, arcLinkLabelsDiagonalLength: 24, arcLinkLabelsTextColor: "#333333", arcLinkLabelsThickness: 2, arcLinkLabelsColor: { from: 'color' }, arcLabelsSkipAngle: 10, arcLabelsTextColor: {
            from: 'color',
            modifiers: [
                [
                    'darker',
                    2
                ]
            ]
        }, legends: [
            Object.assign(Object.assign({}, (legendPosition === 'bottom' ? {
                anchor: 'bottom',
                direction: 'row',
                translateX: 0,
                translateY: 56,
            } : {
                anchor: 'bottom-right',
                direction: 'column',
                translateX: 120,
                translateY: 0,
            })), { justify: false, itemsSpacing: 0, itemWidth: 100, itemHeight: 18, itemTextColor: '#999', itemDirection: 'left-to-right', itemOpacity: 1, symbolSize: 18, symbolShape: 'circle', effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000'
                        }
                    }
                ] })
        ] }, chartProps));
};
exports.TGPieChart = TGPieChart;
const SAMPLE_PROPS = {
    data: [{ "id": "Group A", "label": "Group A", "value": 205 }, { "id": "Group B", "label": "Group B", "value": 49 }, { "id": "Group C", "label": "Group C", "value": 38 }, { "id": "Group D", "label": "Group D", "value": 315 }, { "id": "Group E", "label": "Group E", "value": 3 }],
    id: 'id',
    value: 'value',
};
exports.default = exports.TGPieChart;
//# sourceMappingURL=TGPieChart.js.map